import DetailByPlayer from './DetailByPlayer';
export default DetailByPlayer;
